import { Box, SxProps } from '@mui/material';

import { useSxStyles } from '~/scenes/PortalModules/Analytics/Rewarding/CompensationEqualityReport/CompensationEqualityCharts/ChartKPI/useStyles';
import { mergeSxProps } from '~/utils/helpers/sxProps';

type PropsType = {
  label?: string;
  value: string | number;
  sx?: SxProps;
};

export const ChartKPI = (props: PropsType) => {
  const { label, value, sx } = props;

  const sxStyles = useSxStyles();

  return (
    <Box sx={mergeSxProps(sxStyles.root, sx)}>
      {!!label && <Box sx={sxStyles.label}>{label}</Box>}
      <Box sx={sxStyles.value}>{value}</Box>
    </Box>
  );
};
